import { type Components, type Theme } from '@mui/material';

export const MuiButtonBase: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    centerRipple: true,
    type: 'button',
  },
  styleOverrides: {
    root: {
      fontFamily: 'inherit',
      // Only MUI icons. A bare `path` also reached any other SVG rendered inside a button — e.g. a
      // DS 2.0 `Alert` in an `AccordionSummary`, whose stroked info circle filled into a solid dot.
      // `:where()` adds no specificity, so this still ties with `MuiTableSortLabel`'s path fills.
      '& :where(.MuiSvgIcon-root) path:not(.important)': { fill: 'currentColor' },
    },
  },
};
